import type { Instrument } from "../definitions/Instrument";

/**
 * Fixture used by `MockApiTransport` (`?mock=1`) — a small representative
 * slice of a venue's real instrument catalog (see
 * `InstrumentCatalogService`'s doc comment for the full response shape),
 * enough to populate a compare-instrument dropdown offline.
 */
export const mockInstrumentCatalog: Instrument[] = [
  { symbol: "EURUSD", name: "EUR/USD", group: "Currencies (Main)" },
  { symbol: "GBPUSD", name: "GBP/USD", group: "Currencies (Main)" },
  { symbol: "USDJPY", name: "USD/JPY", group: "Currencies (Main)" },
  { symbol: "AUDUSD", name: "AUD/USD", group: "Currencies (Main)" },
  { symbol: "USDCHF", name: "USD/CHF", group: "Currencies (Main)" },
  { symbol: "USDCAD", name: "USD/CAD", group: "Currencies (Main)" },
  { symbol: "NZDUSD", name: "NZD/USD", group: "Currencies (Main)" },
  { symbol: "EURGBP", name: "EUR/GBP", group: "Currencies (Minor)" },
  { symbol: "EURJPY", name: "EUR/JPY", group: "Currencies (Minor)" },
  { symbol: "GBPJPY", name: "GBP/JPY", group: "Currencies (Minor)" },
];
